import { render, staticRenderFns } from "./ClientStagesPage.vue?vue&type=template&id=197274ca&scoped=true"
import script from "./ClientStagesPage.vue?vue&type=script&lang=js"
export * from "./ClientStagesPage.vue?vue&type=script&lang=js"
import style0 from "./ClientStagesPage.vue?vue&type=style&index=0&id=197274ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197274ca",
  null
  
)

export default component.exports